import dayjs from "dayjs";
import { clock, zoneLabel, zoneLocal, zoneOptions, zoneToUtc, type Zone } from "../lib/zones";

/** Times from 6:00 AM to 10:00 PM in quarter hours (00, 15, 30, 45). */
const TIMES = Array.from({ length: (22 - 6) * 4 + 1 }, (_, i) => {
  const h = 6 + Math.floor(i / 4), m = (i % 4) * 15;
  const v = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  return { value: v, label: clock(`2000-01-01T${v}`) };
});

/** "YYYY-MM-DDTHH:mm" on a province's clock → real moment (ISO), or "" */
export const meetingIso = (local: string, zone: Zone) => (local && local.includes("T") ? zoneToUtc(local, zone) : "");
/** The next whole hour, tomorrow if it's late (never the current minute) */
export const nextHourLocal = (zone: Zone = "ON") => {
  const now = zoneLocal(Date.now(), zone); const h = Number(now.slice(11, 13)) + 1;
  return h >= 18 || h < 8 ? `${dayjs(now.slice(0, 10)).add(h >= 18 ? 1 : 0, "day").format("YYYY-MM-DD")}T10:00` : `${now.slice(0, 10)}T${String(h).padStart(2, "0")}:00`;
};

/**
 * Pick a meeting's date, time (on the hour or quarter hour) and province time zone. Ontario (Toronto) by default.
 * value is the clock time in that province: "YYYY-MM-DDTHH:mm".
 */
export function MeetingWhen({ value, zone, onChange, disabled }: { value: string; zone: Zone; onChange: (local: string, zone: Zone) => void; disabled?: boolean }) {
  const [d, t = ""] = value ? value.split("T") : ["", ""];
  const time = t.slice(0, 5);
  const times = time && !TIMES.some((x) => x.value === time) ? [{ value: time, label: clock(`2000-01-01T${time}`) }, ...TIMES] : TIMES;
  const iso = meetingIso(value, zone);
  const on = iso ? zoneLocal(iso, "ON") : "";
  return (
    <div className="meeting-when">
      <div className="row-inline" style={{ margin: 0, flexWrap: "wrap", gap: 6 }}>
        <input type="date" className="input" style={{ width: 160 }} disabled={disabled} value={d} onChange={(e) => onChange(e.target.value ? `${e.target.value}T${time || "10:00"}` : "", zone)} />
        <select className="input" style={{ width: 120 }} disabled={disabled} value={time} onChange={(e) => onChange(`${d || dayjs().add(1, "day").format("YYYY-MM-DD")}T${e.target.value}`, zone)} aria-label="Time">
          {!time && <option value="">Time</option>}
          {times.map((x) => <option key={x.value} value={x.value}>{x.label}</option>)}
        </select>
        <select className="input" style={{ width: 290 }} disabled={disabled} value={zone} onChange={(e) => onChange(value, e.target.value as Zone)} aria-label="Time zone">
          {zoneOptions(iso || undefined).map((o) => <option key={o.value} value={o.value}>{o.value === "ON" ? "Ontario (Toronto) · default" : o.label}</option>)}
        </select>
      </div>
      {zone !== "ON" && iso && <span className="small muted">{clock(value)} {zoneLabel(zone)} is <b style={{ display: "inline" }}>{clock(on)} Toronto time</b>{on.slice(0, 10) !== d ? ` on ${dayjs(on.slice(0, 10)).format("MMM D")}` : ""}. The client's emails show {zoneLabel(zone)}.</span>}
    </div>
  );
}
